import { tablet } from "components/templates/Breakpoints";
import styled from "styled-components";
import Image from "next/image";

export const YugiCallOutImg = styled(Image)<{ marginRight: string }>`
  margin-right: ${(p) => p.marginRight};

  ${tablet} {
    display: none;
  }
`;

export const YugiNewspaper = styled.div`
  translate: 0 5rem;
  scale: 1.5;
  translate: 0 8rem;

  @media only screen and (max-width: 72rem) {
    translate: 0 12rem;
  }

  @media only screen and (max-width: 65rem) {
    translate: 0 16rem;
  }

  @media only screen and (max-width: 60rem) {
    translate: 0 20rem;
  }

  @media only screen and (max-width: 56rem) {
    translate: 0 24rem;
  }

  @media only screen and (max-width: 52.5rem) {
    translate: 0 28rem;
  }

  @media only screen and (max-width: 46.6rem) {
    translate: 0 32rem;
  }
`;
